<template>
	
	<div id="inicio" v-if="about != null">

    <v-row>


    	<!-- info -->
      <v-col md="6" order-md="1" cols="12" order="2" id="about-info">

        <h1 id="about-title">¿Quienes somos?</h1>	

        <div class="pt-10" id="about-info-text" v-html="about.replace(/(?:\r\n|\r|\n)/g, '<br>')"></div>
        
        <v-row class="mt-5 mb-5">
        	<v-col md="6">
						<v-btn rounded x-large dark block class="mr-5" to="/autenticacion/registrar/">Registrarse</v-btn>	
        	</v-col>
        	<v-col md="6">
        		<v-btn rounded x-large block color="info" to="/autenticacion/">Iniciar sesión</v-btn>
        	</v-col>
        </v-row>

      </v-col>
      <!--/ info -->


      <!-- imgs -->
      <v-col md="6" order-md="2" cols="12" order="1" id="about-imgs-container">

      	<v-icon id="about-icon-resp">mdi-send-clock</v-icon>

        <img src="@/assets/img/logo.png" alt="logo" id="about-logo">
				<img src="@/assets/img/about1.webp" alt="quienes somos" id="mujer-sorprendida">
				<img src="@/assets/img/about2.webp" alt="quienes somos" id="mujer-de-pie">

      </v-col>


    </v-row>

	</div>

</template>


<style>
	
	#inicio {
		background-image: url('~@/assets/img/banner.webp');
		background-size: cover;
		overflow: hidden;
		padding-top: 30px;
		padding-bottom: 12px;
		padding-left: 100px;
		padding-right: 100px;
	}


	#about-info {
		z-index: 1000;
	}

	#about-info-text {
		color: #808080;
		font-weight: bold;
		font-size: 14.5px;
		height: 260px;
		overflow: hidden;
	}

	#about-info-text p {
		text-align: justify;
		margin-top: 20px;
	}


	#about-imgs-container {
		position: relative;
	}

	#mujer-sorprendida {
		position: absolute;
		bottom: 0px;
		right: 150px;
	}

	#about-logo {
		width: 200px;
		position: absolute;
		right: 120px;
		bottom: 225px;
	}

	#mujer-de-pie {
		position: absolute;
		bottom: -200px;
		right: -70px;
	}

	#about-icon-resp {
		position: absolute;
		color: #909090 !important;
		top: 30px;
		left: 30px;
		font-size: 200px;
		display: none;
	}


	@media(max-width: 959px) {

		#inicio {
			background: inherit;
			padding: 0px;
		}


		#about-imgs-container {
			overflow: hidden;
			height: 400px;
			background-image: url('~@/assets/img/banner-resp1.webp');
			background-size: cover;
			margin-left: 0px !important;
			margin-right: 0px !important;
		}

		#mujer-sorprendida {
			width: 250px;
			right: 330px;
		}

		#about-logo {
			width: 150px;
			right: 300px;
			bottom: 215px;
		}

		#mujer-de-pie {
			width: 250px;
			right: 130px;
			bottom: -130px;
		}


		#about-info {
			background-image: url('~@/assets/img/banner-resp2.webp');
			background-size: cover;
			padding-left: 100px;
			padding-right: 100px;
			padding-top: 30px;
			padding-bottom: 30px;
		}

		#about-title {
			text-align: center;
		}


		#about-icon-resp {
			display: inline;
		}

	}


	@media(max-width: 759px) {

		#about-icon-resp {
			display: none;
		}

	}


	@media(max-width: 425px) {

		#about-imgs-container {
			height: 350px;
		}

		#about-logo {
			right: 150px;
			bottom: 170px;
		}

		#mujer-sorprendida {
			left: -50px;
			bottom: -40px;
		}

		#mujer-de-pie {
			right: 10px;
			bottom: -180px;
		}


		#about-info {
			padding-left: 40px;
			padding-right: 40px;
		}

	}


	@media(max-width: 320px) {

		#about-logo {
			right: 120px;
		}

		#mujer-de-pie {
			right: -30px;
		}

	}

</style>


<script>
	
	import SettingService from '@/shared/services/SettingService'

	export default
	{
		data() {
			return {
				about: null
			}
		},

		created() {
			this.getAbout()
		},

		methods: {

			async getAbout()
			{
				const resp = await SettingService.get()
				this.about = resp.data.about
			}

		}
	}

</script>